// Canonical PUBLIC production origin. The preview domain is staging-only and
// must never be used as the canonical/SEO URL.
export const SITE_ORIGIN = "https://evony-trategist.kiwi";
